import type { ImgHTMLAttributes } from 'react';

/**
 * T105-FE: priorità di caricamento di un'immagine.
 *
 * Solo il candidato LCP della vista iniziale è `eager` con `fetchpriority="high"`; tutto il resto
 * (carte dietro, slide fuori schermo) resta `lazy`. Il default è NON prioritario: chi chiama deve
 * dichiarare esplicitamente il candidato, perché due immagini `high` nella stessa vista si
 * contendono la banda e annullano il vantaggio.
 *
 * React 18.3 non conosce la prop camelCase `fetchPriority` (avvisa e non la rende): l'attributo va
 * passato in minuscolo, che il browser legge come l'attributo HTML standard.
 */
export type ImageLoadingProps = Pick<ImgHTMLAttributes<HTMLImageElement>, 'loading'> & {
  fetchpriority?: 'high';
};

export function imageLoadingProps(priority = false): ImageLoadingProps {
  return priority ? { loading: 'eager', fetchpriority: 'high' } : { loading: 'lazy' };
}
